<template>
  <div>
    <my-table :title="title"
              :isAdd="isAdd"
              :tableData="tableData"
              :isSearch="isSearch"
              @add="add"
              @pageNumChange="pageNumChange">
      <div slot="table">
        <coupons-table :tableData="tableData.list" @view="view" @update="update" @del="del"></coupons-table>
      </div>
    </my-table>
  </div>
</template>

<script>
  import CouponsTable from "./CouponsTable";
  import MyTable from "../../components/content/myTable/MyTable";
  import {getCouponsBySearch,newVue,delByCouponsId} from "../../network/coupons";

  export default {
    name: "couponsList",
    components: {CouponsTable, MyTable},
    data(){
      return {
        title: "优惠券列表",
        isAdd: true,
        isSearch: false,
        tableData:{},
      }
    },
    created() {
      newVue.obj = this;
      this.common.HeaderLocationTwo.href =  "/coupons/list";
      this.common.HeaderLocationTwo.name =  "优惠券列表"
      this.common.HeaderLocationThree.name = "优惠券列表"
      this.refresh();
    },
    methods:{
      refresh(){
        getCouponsBySearch().then(res => {
          this.tableData = res.data
          for (let i = 0;i<this.tableData.list.length;i++){
            let date = this.tableData.list[i].endReceiveDate;
              // Y = date.getFullYear() + '',
              // M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1),
              // D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate()),
              // h = (date.getHours() < 10 ? '0'+(date.getHours()) : date.getHours()),
              // m = (date.getMinutes() < 10 ? '0'+(date.getMinutes()) : date.getMinutes()),
              // s = (date.getSeconds() < 10 ? '0'+(date.getSeconds()) : date.getSeconds());
            // this.tableData.list[i].endReceiveDate = Y+M+D+h+m+s;
            console.log(Object.prototype.toString.call(date));
          }
        })
      },
      pageNumChange(pageNum){
        this.getCouponsBySearch(pageNum).then(res => {
          this.tableData = res.data
        });
      },
      add(){
        this.$router.push("insert/");
      },
      view(id){
        this.$router.push("data/"+id)
      },
      update(id){
        this.$router.push("insert/"+id)
      },
      del(id){
        this.$confirm('此操作将永久删除该商品, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delByCouponsId(id).then(res => {
              this.refresh()
            }
          )
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
    }
  }
</script>

<style scoped>

</style>
